import classNames from 'classnames';
import { useCallback } from 'react';
import { Button, ButtonProps } from 'yoso';
import { Menu } from '~/components/Icon';
import { useNews, useSidebarStore } from '~/components/Sidebar/Sidebar.hooks';
import styles from './SidebarButton.module.scss';

export type SidebarButtonProps = ButtonProps;

export const SidebarButton = ({ className, ...props }: SidebarButtonProps) => {
  const news = useNews();
  const { setActive } = useSidebarStore();
  const onClick = useCallback(() => {
    setActive(true);
  }, [setActive]);
  return (
    <Button {...props} className={classNames(styles.root, className)} onClick={onClick}>
      <Menu dot={news} display="block" />
    </Button>
  );
};
